import _regeneratorRuntime from "@babel/runtime/regenerator";

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

import { getBlobFromURL } from './getBlobFromURL';
import { embedResources } from './embedResources';
import { toArray, isDataUrl, toDataURL, getMimeType } from './util';
export function embedImages(clonedNode, options) {
  return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (clonedNode instanceof Element) {
              _context.next = 2;
              break;
            }

            return _context.abrupt("return", Promise.resolve(clonedNode));

          case 2:
            return _context.abrupt("return", Promise.resolve(clonedNode).then(function (node) {
              return embedBackground(node, options);
            }).then(function (node) {
              return embedImageNode(node, options);
            }).then(function (node) {
              return embedChildren(node, options);
            }));

          case 3:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
}

function embedBackground(clonedNode, options) {
  var _a;

  return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
    var background;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            background = (_a = clonedNode.style) === null || _a === void 0 ? void 0 : _a.getPropertyValue('background');

            if (background) {
              _context2.next = 3;
              break;
            }

            return _context2.abrupt("return", Promise.resolve(clonedNode));

          case 3:
            return _context2.abrupt("return", Promise.resolve(background).then(function (cssString) {
              return embedResources(cssString, null, options);
            }).then(function (cssString) {
              clonedNode.style.setProperty('background', cssString, clonedNode.style.getPropertyPriority('background'));
              return clonedNode;
            }));

          case 4:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
}

function embedImageNode(clonedNode, options) {
  if (!(clonedNode instanceof HTMLImageElement) || isDataUrl(clonedNode.src)) {
    return Promise.resolve(clonedNode);
  }

  var src = clonedNode.src;
  return Promise.resolve(src).then(function (url) {
    return getBlobFromURL(url, options);
  }).then(function (data) {
    return toDataURL(data.blob, getMimeType(src) || data.contentType);
  }).then(function (dataURL) {
    return new Promise(function (resolve, reject) {
      clonedNode.onload = resolve;
      clonedNode.onerror = reject;
      clonedNode.srcset = '';
      clonedNode.src = dataURL;
    });
  }).then(function () {
    return clonedNode;
  }, function () {
    return clonedNode;
  });
}

function embedChildren(clonedNode, options) {
  return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
    var children, deferreds;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            children = toArray(clonedNode.childNodes);
            deferreds = children.map(function (child) {
              return embedImages(child, options);
            });
            return _context3.abrupt("return", Promise.all(deferreds).then(function () {
              return clonedNode;
            }));

          case 3:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
}